import { Link } from "react-router-dom";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { COMPANY_NAME, P_IVA } from "@/constants/brand";

export const LegalLayout = ({ title, testid, children }) => (
  <div data-testid={testid} className="bg-obsidian text-white min-h-screen">
    <Navbar />
    <main className="pt-32 pb-24 px-5 sm:px-8">
      <div className="max-w-3xl mx-auto">
        <h1 className="font-display text-3xl sm:text-4xl font-extrabold tracking-tight text-white mb-3">{title}</h1>
        <p className="text-xs text-dim mb-10 uppercase tracking-widest">
          Ultimo aggiornamento: Luglio 2026 — {COMPANY_NAME}, P.IVA {P_IVA}
        </p>
        <div className="space-y-8 text-sm sm:text-base leading-relaxed text-muted2">{children}</div>
        <p className="mt-12 text-xs text-dim border border-brand/20 rounded-xl px-4 py-3">
          Nota: questo documento è una bozza generata a scopo dimostrativo e deve essere revisionato dal titolare
          del trattamento prima della pubblicazione ufficiale.
        </p>
        <Link to="/" className="inline-block mt-8 text-sm font-bold text-brand hover:text-brand-hot transition-colors duration-300">
          ← Torna alla home
        </Link>
      </div>
    </main>
    <Footer />
  </div>
);
